import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LabelText from '../LabelText';
import { dispatchOptionField } from '../../../Util/Util';

const Select = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();
	const {form_component, formFields} = props;

	const fv = useSelector(state => state.fv);

	const userData = useSelector(state => state.userData);
	const optionFields = useSelector(state => state.optionFields);
	const curStep = useSelector(state => state.curStep);
	const jumpHistory = useSelector(state => state.jumpHistory) || [];
	
	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			var validator = {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			};

			fv.addField(form_component.fieldname, validator);
		}
	}, [fv]);

	const onChange = (e) => {
		const {value} = e.target;
		const selectedOption = form_component.options.find(opt => opt.value === value);
		dispatchOptionField(
			dispatch, 
			form_component, 
			value, 
			optionFields, 
			curStep, 
			formFields.form_components, 
			selectedOption,
			jumpHistory
		);
	};

	var select_radio_default_value = '';
	form_component.options.map((form_component_option, index) => {
		if (form_component_option.default_select) {
			select_radio_default_value = form_component_option.value;
		}
	});

	return (
		<div className={`flex-grow-1 form-group select ${form_component.required ? 'required' : ''}`}>
			<LabelText
				lang={props.lang}
				form_component={form_component}
			/>
			<select
				type="text"
				name={form_component.fieldname}
				placeholder={form_component.placeholder}
				className="form-select-sm mb-3 form-select"
				id={form_component.fieldname}
				defaultValue={(userData && userData[form_component.fieldname]) || select_radio_default_value}
				onChange={onChange}
			>
				<option value="">{t('請選擇...')}</option>
				{(() => {
					const components = [];

					form_component.options.map((option, index) => {
						components.push(
							<option key={`option-${index}`} value={option.value}>{option.label}</option>
						);
					});

					return components;
				})()}
			</select>
		</div>
	);
}

export default Select;